/** Native dialog behavior, including browsers without command/commandfor. */
class Navigation extends HTMLElement {
  #dialog;
  #trigger;
  #headerObserver;

  connectedCallback() {
    this.#dialog = this.querySelector('.tt-drawer');
    this.#trigger = this.querySelector('.tt-burger');
    this.addEventListener('click', this.#onClick);
    this.#dialog?.addEventListener('close', this.#onClose);
    if (typeof ResizeObserver === 'function') {
      const group = this.closest('#header-group');
      if (group) {
        this.#headerObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--tt-header-height', `${Math.ceil(group.getBoundingClientRect().height)}px`);
        });
        this.#headerObserver.observe(group);
      }
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.#dialog?.removeEventListener('close', this.#onClose);
    this.#headerObserver?.disconnect();
    if (this.#headerObserver) document.documentElement.style.removeProperty('--tt-header-height');
  }

  #onClick = (event) => {
    const button = event.target.closest('[commandfor="tt-menu-drawer"]');
    if (button && this.#dialog) {
      event.preventDefault();
      if (button.getAttribute('command') === 'show-modal') {
        if (!this.#dialog.open) this.#dialog.showModal();
        this.#trigger?.setAttribute('aria-expanded', 'true');
      } else {
        this.#dialog.close();
      }
    } else if (event.target === this.#dialog) {
      this.#dialog.close();
    }
  };

  #onClose = () => {
    this.#trigger?.setAttribute('aria-expanded', 'false');
    this.#trigger?.focus({ preventScroll: true });
  };
}

if (!customElements.get('tt-navigation')) customElements.define('tt-navigation', Navigation);
